import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import Office from "../img/office.png";
import DataImg from "../img/data-points.svg";
import React from "react";

const Lease = () => {
  return (
    <Box h={{ xl: "100vh", base: "100%" }} pt={"80px"}>
      <Container maxW={"85%"}>
        <Grid
          gridTemplateColumns={{ xl: "repeat(2, 1fr)", base: "repeat(1, 1fr)" }}
          gap={10}
        >
          <GridItem>
            <Heading
              fontSize={{ lg: "8xl", md: "5xl", base: "4xl" }}
              textAlign={{ sm: "left", base: "center" }}
              color={"DarkTeal"}
            >
              Lease with Confidence
            </Heading>
            <Text
              w={{ xl: "75%", lg: "80%", md: "90%", base: "100%" }}
              color={"DarkBlue"}
              my={5}
              display={{ md: "inline-block", base: "none" }}
            >
              Our mission is to provide a professional and welcoming environment
              that meets the unique needs of healthcare professionals and their
              patients. We understand the importance of a functional and
              efficient workspace and are committed to delivering exceptional
              service and support to ensure the success of your practice.
            </Text>
          </GridItem>
          <GridItem pos={"relative"}>
            <Box display={{ md: "none", base: "block" }}>
              <Box
                pos={"relative"}
                w={{ lg: "373px", base: "100%" }}
                margin={{ lg: "unset", base: "0 auto" }}
              >
                <Box
                  bgColor={"rgba(64, 224, 208, 0.2)"}
                  w={{ lg: "248px", base: "208px" }}
                  h={{ lg: "248px", base: "208px" }}
                  textAlign={"center"}
                  borderRadius={"full"}
                  margin={{ md: 0, base: "0 auto" }}
                >
                  <Heading
                    fontSize={{ lg: "8xl", base: "5xl" }}
                    fontStyle={"italic"}
                    lineHeight={{ lg: "248px", base: "208px" }}
                    color={"BrightTurquoise"}
                  >
                    36
                  </Heading>
                </Box>
                <Text
                  w={"204px"}
                  color={"DarkTeal"}
                  pos={{ lg: "absolute", base: "relative" }}
                  top={0}
                  right={0}
                  margin={{ md: 0, base: "40px auto 90px" }}
                  textAlign={{ md: "left", base: "center" }}
                >
                  States with Welltower Properties
                </Text>
              </Box>
              <Box
                pos={{ lg: "absolute", base: "relative" }}
                w={{ lg: "447px", base: "100%" }}
                margin={{ lg: "unset", base: "0 auto" }}
                right={0}
                top={{ lg: 20, base: 0 }}
              >
                <Box
                  bgColor={"rgb(41 100 145 / 20%)"}
                  w={{ lg: "330px", base: "208px" }}
                  h={{ lg: "330px", base: "208px" }}
                  textAlign={"center"}
                  borderRadius={"full"}
                  margin={{ md: 0, base: "0 auto" }}
                >
                  <Heading
                    fontSize={{ lg: "7xl", base: "5xl" }}
                    fontStyle={"italic"}
                    lineHeight={{ lg: "330px", base: "208px" }}
                    color={"DarkTeal"}
                  >
                    100+
                  </Heading>
                </Box>
                <Text
                  w={"204px"}
                  color={"DarkTeal"}
                  pos={{ lg: "absolute", base: "relative" }}
                  top={{ md: 8, base: 0 }}
                  right={0}
                  margin={{ md: 0, base: "40px auto 90px" }}
                  textAlign={{ md: "left", base: "center" }}
                >
                  Health Systems Served
                </Text>
              </Box>
              <Box
                pos={"relative"}
                w={{ lg: "342px", base: "100%" }}
                mt={8}
                margin={{ lg: "unset", base: "0 auto" }}
              >
                <Box
                  bgColor={"rgb(38 85 90 / 20%)"}
                  w={{ lg: "221px", base: "218px" }}
                  h={{ lg: "221px", base: "218px" }}
                  textAlign={"center"}
                  borderRadius={"full"}
                  margin={{ md: 0, base: "0 auto" }}
                >
                  <Heading
                    fontSize={{ lg: "7xl", base: "5xl" }}
                    fontStyle={"italic"}
                    lineHeight={{ lg: "211px", base: "208px" }}
                    color={"#26555A"}
                  >
                    ~26
                  </Heading>
                </Box>
                <Text
                  w={"184px"}
                  color={"DarkTeal"}
                  pos={{ lg: "absolute", base: "relative" }}
                  bottom={{ md: 8, base: 0 }}
                  right={0}
                  margin={{ md: 0, base: "40px auto 90px" }}
                  textAlign={{ md: "left", base: "center" }}
                >
                  Million SQ.FT. of Outpatient Facilities
                </Text>
              </Box>
            </Box>
            <Image mb={{lg: 0, md: 24, base:0 }} src={DataImg} display={{ base: "none", md: "inline-block" }} />
            <Text
              color={"DarkBlue"}
              mb={20}
              display={{ md: "none", base: "inline-block" }}
              textAlign={{ md: "left", base: "center" }}
            >
              Our mission is to provide a professional and welcoming environment
              that meets the unique needs of healthcare professionals and their
              patients. We understand the importance of a functional and
              efficient workspace and are committed to delivering exceptional
              service and support to ensure the success of your practice.
            </Text>
          </GridItem>
        </Grid>
      </Container>
      <Image
        display={{ md: "none", base: "inline-block" }}
        src={Office}
        pos={"relative"}
        bottom={"-7px"}
      />
    </Box>
  );
};

export default Lease;
